import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/pixel';
type ButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
};
export function Button({
  children,
  onClick,
  href,
  className = ''
}: ButtonProps) {
  const classes = `inline-block text-center bg-cream text-terracotta border-2 border-terracotta font-sans font-semibold py-4 px-8 rounded-full shadow-lg hover:bg-terracotta hover:text-cream transition-colors w-full sm:w-auto text-lg ${className}`;
  // If href is provided → external link (e.g. cart). Fire AddToCart on click.
  if (href) {
    return <motion.a href={href} target="_top" rel="noopener noreferrer" onClick={() => {
      trackAddToCart();
      if (onClick) onClick();
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={classes} data-id="element-17">
        {children}
      </motion.a>;
  }
  // Default → scroll to the last section of the page (no AddToCart event)
  const handleScrollToEnd = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
    if (onClick) onClick();
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleScrollToEnd} className={classes} data-id="element-18">
      {children}
    </motion.button>;
}